import React from 'react';
import { FaMoon, FaSun } from 'react-icons/fa';
import { useTheme } from '../contexts/ThemeContext';

const ThemeToggle: React.FC = () => {
  const { mode, toggleTheme } = useTheme();
  const label = `Switch to ${mode === 'dark' ? 'light' : 'dark'} mode`;
  return <button type="button" className="theme-toggle icon-btn" onClick={toggleTheme} aria-label={label} title={label} aria-pressed={mode === 'dark'}>
    {mode === 'dark' ? <FaSun aria-hidden="true" /> : <FaMoon aria-hidden="true" />}
  </button>;
};
export default ThemeToggle;
